var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-template"},[_c('AuthLocaleSelector',{staticClass:"auth-template__locale-selector"}),_vm._v(" "),_c('THeading',{staticClass:"auth-template__heading",class:_vm.isHeadingMargin4 ? 'mb-4' : 'mb-2'},[_vm._t("heading")],2),_vm._v(" "),[_vm._t("heading-follower")],_vm._v(" "),[_vm._t("form")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }